<div class="flex flex-col h-full">
  <div class="flex justify-between items-center mb-4 mt-4">
    <div class="flex flex-1"></div>
    <div class="flex flex-1 justify-center">
      <elcia-period-navigator
        (periodChange)="onPeriodChange($event)"
        [periodTypes]="[PeriodType.Month, PeriodType.Week, PeriodType.Year]"/>
    </div>
    <div class="flex flex-1 flex-row-reverse gap-2">
      <elcia-button (onClick)="showLive()" [icon]="'phone'" [label]="'call-statistic.live' | translate"
                    [severity]="'secondary'"/>
    </div>
  </div>

  <div class="grid grid-cols-2 gap-3 md:grid-cols-4 xl:grid-cols-7 mb-4">
    @for (card of cards(); track card.label) {
      <elcia-call-statistic-card [label]="card.label | translate" [value]="card.value"/>
    }
  </div>

  <div class="flex-1 overflow-hidden">
    @if (isLoading()) {
      <elcia-loader/>
    } @else {
      <elcia-call-statistic-grid [callStatistics]="callStatistics()"/>
    }
  </div>
</div>

@if (isLiveDisplayed()) {
  <elcia-dialog
    (onClose)="closeLive()"
    [mustDisplayActionButton]="false"
    [size]="'x-small'"
    [title]="'call-statistic.live-title' | translate">

    @if (isLoadingLive()) {
      <elcia-loader/>
    } @else if (isLiveError()) {
      <p class="text-sm text-red-600">{{ 'call-statistic.live-error' | translate }}</p>
    } @else {
      @if (liveStatistics(); as live) {
        <div class="flex flex-col gap-2">
          <div class="flex justify-between gap-4">
            <span>{{ 'call-statistic.calls-total' | translate }}</span>
            <span class="font-semibold tabular-nums">{{ live.callsTotal }}</span>
          </div>
          <div class="flex justify-between gap-4">
            <span>{{ 'call-statistic.calls-answered' | translate }}</span>
            <span class="font-semibold tabular-nums">{{ live.callsAnswered }}</span>
          </div>
          <div class="flex justify-between gap-4">
            <span>{{ 'call-statistic.calls-lost' | translate }}</span>
            <span class="font-semibold tabular-nums">{{ live.callsLost }}</span>
          </div>
          <div class="flex justify-between gap-4">
            <span>{{ 'call-statistic.total-call-duration' | translate }}</span>
            <span class="font-semibold tabular-nums">{{ live.totalCallDuration | callDuration }}</span>
          </div>
          <div class="flex justify-between gap-4">
            <span>{{ 'call-statistic.total-waiting-duration' | translate }}</span>
            <span class="font-semibold tabular-nums">{{ live.totalWaitingDuration | callDuration }}</span>
          </div>
          <div class="flex justify-between gap-4">
            <span>{{ 'call-statistic.last-reset' | translate }}</span>
            <span class="tabular-nums">{{ live.lastReset | date: 'dd/MM/yyyy HH:mm' }}</span>
          </div>
        </div>

        <p class="mt-4 text-xs text-[var(--p-surface-500)]">{{ 'call-statistic.live-hint' | translate }}</p>
      }
    }
  </elcia-dialog>
}
